import { render, staticRenderFns } from "./NewNgbTeamMembersList.vue?vue&type=template&id=2499b5b1"
import script from "./NewNgbTeamMembersList.vue?vue&type=script&lang=js"
export * from "./NewNgbTeamMembersList.vue?vue&type=script&lang=js"
import style0 from "./NewNgbTeamMembersList.vue?vue&type=style&index=0&id=2499b5b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports